import React from "react";
import { Form, InputNumber, message, Modal } from "antd";
import { InjectBaseModalProps } from "@/hooks/Modal/ModalStore";
import { useRequest } from "ahooks";
import { changeQuantity } from "@/services/api/sharedEwaybillShippingAddress";
import { getPositiveNumberRule } from "@/util/formValidatorRules";

export interface SubtractCountModalProps extends InjectBaseModalProps {
  shippingAddressId: number;

  reload?(): void;
}

interface FormValues {
  quantity: number;
}

const SubtractCountModal: React.FC<SubtractCountModalProps> = function (props) {
  const { visible, onCancel, shippingAddressId, reload } = props;

  const [form] = Form.useForm<FormValues>();

  const { run, loading } = useRequest(
    async () => {
      const { quantity } = await form.validateFields();

      await changeQuantity(shippingAddressId, -quantity);

      message.success("减少单数成功");

      onCancel?.();
      reload?.();
    },
    {
      manual: true,
    }
  );

  return (
    <Modal
      title="减少单数"
      width={420}
      visible={visible}
      confirmLoading={loading}
      onCancel={onCancel}
      destroyOnClose={true}
      okText="确定"
      onOk={run}
    >
      <Form form={form}>
        <Form.Item name="quantity" rules={[getPositiveNumberRule()]}>
          <InputNumber
            placeholder="请输入减少的单号数量"
            style={{ margin: "0 10px", width: "100%" }}
            min={0}
            precision={0}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default React.memo(SubtractCountModal);
